import React, { forwardRef } from 'react';

/**
 * Terminal input component with prompt.
 * Admin mode removed in v3.1.1 — only the guest prompt remains.
 */
const TerminalInput = forwardRef(({ input, setInput, onKeyDown }, ref) => {
  return (
    <div className="terminal-input-wrapper">
      <span className="terminal-prompt">
        guest@c4sh3r-portfolio:~<span className="prompt-sigil">$</span>
      </span>
      <input
        ref={ref}
        type="text"
        className="terminal-input"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={onKeyDown}
        autoFocus
        spellCheck="false"
        autoComplete="off"
        style={{ caretColor: 'var(--cyan-primary)' }}
      />
    </div>
  );
});

TerminalInput.displayName = 'TerminalInput';

export default TerminalInput;
